import { render, staticRenderFns } from "./LogoutSuccess.vue?vue&type=template&id=f930cbf4&scoped=true&"
import script from "./LogoutSuccess.vue?vue&type=script&lang=js&"
export * from "./LogoutSuccess.vue?vue&type=script&lang=js&"
import style0 from "./LogoutSuccess.vue?vue&type=style&index=0&id=f930cbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f930cbf4",
  null
  
)

export default component.exports